class WebSocketClient {
  constructor(config) {
    const defaultConfig = {
      ...{
        url: null,
        reconnectInterval: 1000,
        heartbeat: false,
        heartbeatInterval: 60000,
        reconnecting: false
      },
      ...config
    }
    console.log(defaultConfig)
    this.url = defaultConfig.url // ws地址
    this.reconnectInterval = defaultConfig.reconnectInterval // 重连间隔
    this.heartbeat = defaultConfig.heartbeat // 是否发送心跳
    this.heartbeatInterval = defaultConfig.heartbeatInterval
    this.ws = null
    this.reconnecting = defaultConfig.reconnecting
    this.messageHandlers = [] // 存储所有注册的消息处理函数
    this.openHandlers = []
    this.closeHandlers = []
    this.heartbeatWorker = null
    if (!this.url) return
    this.init()
  }
  init() {
    this.connect()
    this.ws.onopen = event => {
      console.log('WebSocket Connection Opened!', event)
      this.sendMessage('I')
      // 连接成功以后判断是否发送心跳
      if (this.heartbeat) {
        // 创建线程
        this.initWorker()
      }
      this.handlerOpen(event)
    }

    this.ws.onmessage = event => {
      this.handleMessage(event) // 调用所有注册的消息处理函数
    }
    this.ws.onclose = event => {
      console.log('链接关闭!', event)
      this.ws = null
      if (!this.reconnecting) {
        this.reconnect()
      }
      this.handleClose(event)
    }
    this.ws.onerror = error => {
      console.error('链接发生错误', error)
      this.reconnect()
    }
  }
  initWorker() {
    // 如果存在 先销毁
    if (this.heartbeatWorker) {
      this.heartbeatWorker.terminate()
      this.heartbeatWorker = null
    }
    const url = process.env.BASE_URL + 'worker.js'
    this.heartbeatWorker = new Worker(url)
    // 发送启用心跳定时器
    this.heartbeatWorker.postMessage({
      type: 'heartbeat',
      heartbeatInterval: this.heartbeatInterval
    })
    // 监听woker传回来的消息
    this.heartbeatWorker.onmessage = event => {
      const data = event.data
      if (data.type === 'heartbeat') {
        this.sendMessage('I')
      }
    }
  }
  connect() {
    if (this.ws) {
      this.ws.close()
    }
    this.ws = new WebSocket(this.url)
  }
  close() {
    if (this.ws) {
      this.ws.close()
      this.heartbeatWorker &&
        this.heartbeatWorker.postMessage({
          type: 'close',
          heartbeatInterval: this.heartbeatInterval
        })
    }
    this.reconnecting = true
  }
  reconnect() {
    if (this.reconnecting) return
    this.reconnecting = true
    setTimeout(() => {
      console.log('重连中...')
      this.init()
      this.reconnecting = false
    }, this.reconnectInterval)
  }
  // 允许外部注册消息处理函数
  onMessage(handler) {
    if (typeof handler === 'function') {
      this.messageHandlers.push(handler)
    }
  }
  // 处理接收到的消息，并调用所有注册的消息处理函数
  handleMessage(message) {
    for (const handler of this.messageHandlers) {
      handler(message)
    }
  }
  // 外部注册打开连接处理函数
  onOpen(handler) {
    if (typeof handler === 'function') {
      this.openHandlers.push(handler)
    }
  }
  onClose(handler) {
    if (typeof handler === 'function') {
      this.closeHandlers.push(handler)
    }
  }
  handleClose(message) {
    for (const handler of this.closeHandlers) {
      handler(message)
    }
  }
  handlerOpen(message) {
    for (const handler of this.openHandlers) {
      handler(message)
    }
  }
  // 其他WebSocket相关的方法，如发送消息等...
  sendMessage(message) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(message)
    } else {
      console.error('WebSocket is not open. Message not sent:', message)
    }
  }
}
export default WebSocketClient
